import {HTTP} from '../http-common';
import {UTILS} from '../http-common';
import discovery from '../discovery';

export default {
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            'authorization': 'Bearer ' + window.kc_token
        };
 
        ///////////////////////////////////////////////////////////////
        // FIX multiples perfiles

        let employeeCompany = this.getContextValue('worktime.employee.company.id');
        if (employeeCompany) {
            headers['x-employee-company'] = employeeCompany;
            headers['x-client-company'] = employeeCompany;
        }

        ///////////////////////////////////////////////////////////////

        let adminCompany = this.getContextValue('worktime.admin.company.id');
        if (adminCompany) {
            headers['x-admin-company'] = adminCompany;
        }

        let employeeId = window.localStorage.getItem('worktime.employee.id');
        if (employeeId) {
            headers['x-employee'] = employeeId;
        }

        const companyId = adminCompany ? adminCompany : employeeCompany;

        const wpFilterKey = `filter.company_id_${companyId}.workplace.id`;
			
        const workplaceId = window.localStorage.getItem(wpFilterKey);
        if (workplaceId && workplaceId !== "-1") {
            headers['x-workplace'] = workplaceId;
        }

        const dpFilterKey = `filter.company_id_${companyId}.department.id`;
			
        const departmentId = window.localStorage.getItem(dpFilterKey);
        if (departmentId && departmentId !== "-1") {
            headers['x-department'] = departmentId;
        }

        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(discovery.worktime_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(discovery.worktime_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                if (cbok)
                    cbok(response.data);
            }).catch(function (error) {
                if (cberr)
                    cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(discovery.worktime_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(discovery.worktime_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    getContextValue(key)
    {
        return window.tweemContext ? window.tweemContext[key]:'';
    },
    /////////////////////////////////////////////////////////////////
    //COMMON 
    
	getStaff (cbok, cberr)
    {
        this.genericGet('admin/staff', cbok, cberr);
    },
    getWorkPlaces (cbok, cberr)
    {
        this.genericGet('admin/getworkPlace', cbok, cberr);
    },
    getProjects (cbok, cberr)
    {
        this.genericGet('admin/projectsAll', cbok, cberr);
    },
    executeQuery (data, cbok, cberr)
    {
        this.genericPost('analytics/executeQuery', data, cbok, cberr);
    },
	getCompanies (cbok, cberr)
    {
        this.genericGet('admin/companies', cbok, cberr);
    },
    getWorkplacesByCompanyId(companyId, cbok, cberr)
		{
        this.genericGet('admin/workplaces-by-company-id/'+ companyId, cbok, cberr);
    },

     /////////////////////////////////////////////////////////////////
    //Dialog manager

    getDialog (id, cbok, cberr)
    {
        this.genericGet('dialog/'+id, cbok, cberr);
    },    
    deleteDialog (id, cbok, cberr)
    {
        this.genericDelete('dialog/'+id, cbok, cberr);
    },   
    storeDialog(module, cbok, cberr)
    {
        this.genericPost('dialog/', module, cbok, cberr);
    },    
    getDialogs (cbok, cberr)
    {
        this.genericGet('dialog/config', cbok, cberr);
    }, 

    /////////////////////////////////////////////////////////////////
    //Module manager

    getModule (id, cbok, cberr)
    {
        this.genericGet('module/'+id, cbok, cberr);
    },    
    deleteModule (id, cbok, cberr)
    {
        this.genericDelete('module/'+id, cbok, cberr);
    },   
    storeModule (module, cbok, cberr)
    {
        this.genericPost('module/', module, cbok, cberr);
    },    
    getModules (cbok, cberr)
    {
        this.genericGet('module/config', cbok, cberr);
    }, 
    getModuleData (id, context, cbok, cberr)
    {
        this.genericPost('module/data/' + id, context, cbok, cberr);
    }, 
    /////////////////////////////////////////////////////////////////
    //Export module

    downloadExportCSV(id, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(discovery.worktime_service_url + 'admin/download-export-csv/' + id, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },
    getLinkDownloadExportCSV(id, cbok, cberr)
    {   
        HTTP
            .get(discovery.worktime_service_url + 'admin/export-csv-link/' + id, this.getCommonHeaders())
            .then((response) => {
                if (cbok) {
                    let url = discovery.worktime_service_url;
                    url = url.replace('/rest/', '');
                    url = `${url}/${response.data}`;
                    cbok(url);
                }
            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },    
    deleteExport (id, cbok, cberr)
    {
        this.genericDelete('admin/delete-export/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //External document category

    getExternalDocumentCategory (id, cbok, cberr)
    {
        this.genericGet('admin/external-document-category-by-id/'+id, cbok, cberr);
    },    
    deleteExternalDocumentCategory (id, cbok, cberr)
    {
        this.genericDelete('admin/external-document-category/'+id, cbok, cberr);
    },   
    storeExternalDocumentCategory (data, cbok, cberr)
    {
        this.genericPost('admin/external-document-category', data, cbok, cberr);
    }, 

    /////////////////////////////////////////////////////////////////
    //Support ticket

    getSupportTicket (isAdmin,id, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericGet(path+'/ticket/'+id, cbok, cberr);
    },    
    getSupportTicketMessages (isAdmin, id, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericGet(path+'/ticket/'+id+'/message', cbok, cberr);
    }, 
    deleteSupportTicket (id, cbok, cberr)
    {
        this.genericDelete('support/admin/ticket/'+id, cbok, cberr);
    },   
    storeSupportTicket (isAdmin, data, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericPost(path+'/ticket', data, cbok, cberr);
    },  
    storeSupportTicketMessage (isAdmin, data, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';
        this.genericPost(path+'/ticket/'+data.ticketId+'/message', data, cbok, cberr);
    },  
    downloadSupportMessageFile (isAdmin, ticketId, messageId, fileId, cbok, cberr)
    {
        let path = isAdmin ? 'support/admin' : 'support/customer';

        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(discovery.worktime_service_url+path+'/ticket/'+ticketId+'/message/'+messageId+'/file/'+fileId,options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },

    /////////////////////////////////////////////////////////////////
    //AUDITLOG
    
    getAuditLog (id, cbok, cberr)
    {
        this.genericGet('admin/audit-log/'+id, cbok, cberr);
    },   

    /////////////////////////////////////////////////////////////////
    //DASHBOARD
    
    getWidgets (cbok, cberr)
    {
        this.genericGet('dashboard/config', cbok, cberr);
    }, 
    getWidgetData (id, context, cbok, cberr)
    {
        this.genericPost('dashboard/data/' + id, context, cbok, cberr);
    }, 

    /////////////////////////////////////////////////////////////////
    //REPORT_TYPE 

    getReportTypes (offset, size, search, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet('admin/report-type/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy+ '&sortDesc=' + sortDesc, cbok, cberr);
    }, 
	getReportTypeById (id, cbok, cberr)
    {
        this.genericGet('admin/report-type-by-id/' + id, cbok, cberr);
    },   
	storeReportType (data, cbok, cberr)
    {
        this.genericPost('admin/report-type', data, cbok, cberr);
    },    
	deleteReportTypeById (id, cbok, cberr)
    {
        this.genericDelete('admin/report-type/' + id, cbok, cberr);
    },
    getSupersetGuestToken (id, cbok, cberr)
    {
        this.genericGet('analytics/reportType/' + id + '/guestToken', cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //KIOSK
    getKiosks (offset, size, search, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet('admin/kiosk/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy+ '&sortDesc=' + sortDesc, cbok, cberr);
    }, 
    getKioskById (id, cbok, cberr)
    {
        this.genericGet('admin/kiosk-by-id/' + id, cbok, cberr);
    },
    storeKiosk (data, cbok, cberr)
    {
        this.genericPost('admin/kiosk', data, cbok, cberr);
    },    
    deleteKiosk (id, cbok, cberr)
    {
        this.genericDelete('admin/kiosk/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //PROJECTCALENDAR

    getEmployeeCalendarPaginated (request, cbok, cberr)
    {
        this.genericPost('admin/employeeCalendar', request, cbok, cberr);
    }, 

    /////////////////////////////////////////////////////////////////
    //CUSTOMERS

	getCompaniesPaginated (offset, size, search, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet('admin/companies/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy+ '&sortDesc=' + sortDesc, cbok, cberr);
    }, 
	getPartners  (cbok, cberr)
    {
        this.genericGet('admin/getPartners', cbok, cberr);
    },
    getCompanyById (id, cbok, cberr)
    {
        this.genericGet('admin/company-by-id/' + id, cbok, cberr);
    },
    storeCompany (data, cbok, cberr)
    {
        this.genericPost('admin/companies', data, cbok, cberr);
    },    
    deleteCompany (id, cbok, cberr)
    {
        this.genericDelete('admin/companies/' + id, cbok, cberr);
    },   
    uploadEmployeesFile (data, cbok, cberr)
    {
        var headers = this.getCommonHeaders().headers;
        headers['Content-Type'] = 'multipart/form-data';
				
        HTTP.post(discovery.worktime_service_url+'admin/uploadEmployees',
            data, {
							headers: headers
            })
            .then((response) => {
                cbok(response.data, false);
            }).catch(function (error) {
                if (error.response) {
                    cbok(error.response.data, true);
                    return;
                }
                cberr(error);
            });
    },
    importEmployees (companyId, deleteFile)
    {
        this.genericPut(`admin/importEmployees/${companyId}/${deleteFile}`);
    },
    
    /////////////////////////////////////////////////////////////////
    //FORMS 
    
	getForms (offset, size, search, sortBy, sortDesc, cbok, cberr)
    {
        this.genericGet('admin/form/' + offset + '/' + size + '?search=' + search + '&sortBy=' + sortBy+ '&sortDesc=' + sortDesc, cbok, cberr);
    }, 
	getFormById (id, cbok, cberr)
    {
        this.genericGet('admin/form/' + id, cbok, cberr);
    }, 
    hasFormSubmissions (id, cbok, cberr)
    {
        this.genericGet('admin/form/'+id+'/has-submissions', cbok, cberr);
    },  
	storeForm (data, cbok, cberr)
    {
        this.genericPost('admin/form', data, cbok, cberr);
    },    
	deleteForm(id, cbok, cberr)
    {
        this.genericDelete('admin/form/' + id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //SURVEYS  

    getSurveySubmissions (id, cbok, cberr)
    {
        this.genericGet('admin/survey/'+id+'/submissions', cbok, cberr);
    }, 

    /////////////////////////////////////////////////////////////////
    //ASSESSMENT  

    getAssessmentSubmissions (id, cbok, cberr)
    {
        this.genericGet('admin/assessment/'+id+'/submissions', cbok, cberr);
    }, 

    ////////////////////////////////////////////////////
    //DATA BAGS

    getDataBag (key, cbok, cberr)
    {
        this.genericGet('user/databag/'+key, cbok, cberr);
    },  
	storeDataBag (data, cbok, cberr)
    {
        this.genericPost('user/databag', data, cbok, cberr);
    },    
	deleteDataBag(id, cbok, cberr)
    {
        this.genericDelete('user/databag/' + id, cbok, cberr);
    },
    ////////////////////////////////////////////////////
    //ADMIN CONFIGURATION
    getAdminCongiguration (id, cbok, cberr)
    {
        this.genericGet('admin/config/'+id, cbok, cberr);
    },  
	storeAdminCongiguration(data, cbok, cberr)
    {
        this.genericPost('admin/config', data, cbok, cberr);
    },    
	deleteAdminCongiguration (id, cbok, cberr)
    {
        this.genericDelete('admin/config/'+id, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //AI SEARCH
    
    doAISearch (topic, prompt, cbok, cberr)
    {
        this.genericGet('ai/search?t='+topic+'&q='+encodeURI(prompt), cbok, cberr);
    }, 
    getAISearchData (id, context, cbok, cberr)
    {
        this.genericPost('ai/data/' + id, context, cbok, cberr);
    }, 

    ////////////////////////////////////////////////////
    //ACTIVITY TYPE

    getActivityTypeById (id, cbok, cberr)
    {
        this.genericGet('admin/activity-types-by-id/'+id, cbok, cberr);
    },  
	storeActivityType(data, cbok, cberr)
    {
        this.genericPost('admin/activity-type', data, cbok, cberr);
    },  
    testActivityTypeScript(data, cbok, cberr)
    {
        this.genericPost('admin/activity-type/test-script', data, cbok, cberr);
    },   
	deleteActivityType (id, cbok, cberr)
    {
        this.genericDelete('admin/activity-type/'+id, cbok, cberr);
    },
    getActivityCountByActivityType(id, cbok, cberr){
        this.genericGet('admin/activity-count-by-activity-type/'+id, cbok, cberr);
    },
    /*getWorkPlaces(cbok, cberr)
    {
        this.genericGet('admin/getworkPlace', cbok, cberr);
    },*/

    ////////////////////////////////////////////////////
    //DEPARTMENT

    getDepartments(data, cbok, cberr)
    {
        this.genericGet('admin/departments', data, cbok, cberr);
    },
    getDepartmentById(id, cbok, cberr)
    {
        this.genericGet('admin/departments/'+id, cbok, cberr);
    },  
	storeDepartment(data, cbok, cberr)
    {
        this.genericPost('admin/departments', data, cbok, cberr);
    },    
	deleteDepartment(id, cbok, cberr)
    {
        this.genericDelete('admin/departments/'+id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //DOCUMENT CATEGORY

    getDocumentCategoryById(id, cbok, cberr)
    {
        this.genericGet('admin/document-category-by-id/'+id, cbok, cberr);
    },
	storeDocumentCategory(data, cbok, cberr)
    {
        this.genericPost('admin/document-category', data, cbok, cberr);
    },
	deleteDocumentCategory(id, cbok, cberr)
    {
        this.genericDelete('admin/document-category/'+id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //DIALOG BUILDER

    dialogBuilderGET (path, cbok, cberr)
    {
        this.genericGet(path, cbok, cberr);
    },  
	dialogBuilderPOST (path,data, cbok, cberr)
    {
        this.genericPost(path, data, cbok, cberr);
    },    
	dialogBuilderDELETE(path, cbok, cberr)
    {
        this.genericDelete(path, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //CALENDAR

    getCalendars (cbok, cberr)
    {
        this.genericGet('admin/calendar', cbok, cberr);
    },
    copyCalendarExercise (data, cbok, cberr)
    {
        this.genericPost('admin/copyCalendarExercise', data, cbok, cberr);
    },
    getCountry (id, cbok, cberr)
    {
        this.genericGet('admin/country/' + id, cbok, cberr);
    },
	getCalendarHolidays (countryId, stateId, locale, year, cbok, cberr)
    {
        this.genericGet(`admin/getCalendarHolidays/${countryId}/${stateId}/${locale}/${year}`, cbok, cberr);
    },
    addCalendarHolidays (data, cbok, cberr)
    {
        this.genericPost('admin/addCalendarHolidays', data, cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //REFUND TRANSACTION

    refundTransaction(id, cbok, cberr)
    {
        this.genericPut('admin/refund/'+id, null, cbok, cberr);
    },  
    getTransactions(cbok, cberr) {
        this.genericGet('admin/transactions', cbok, cberr);
    },

    /////////////////////////////////////////////////////////////////
    //Complaint

    getComplaint (id, cbok, cberr)
    {
        this.genericGet('complaint/get-full-complaint/'+id, cbok, cberr);
    },
    createComplaint (data, cbok, cberr)
    {
        this.genericPost('complaint/create-complaint', data, cbok, cberr);
    },   
    updateComplaint (data, cbok, cberr)
    {
        this.genericPut('complaint/update-complaint', data, cbok, cberr);
    },   
    downloadComplaintFile (companyId, complaintId, fileId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(discovery.worktime_service_url+'complaint/download-complaint-file-by-id/'+companyId+'/'+complaintId+'/'+fileId, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
              });
    },  
    createComplaintMessage (data, cbok, cberr)
    {
        this.genericPost('complaint/create-complaint-message', data, cbok, cberr);
    },  
    downloadComplaintMessageFile (companyId, complaintId, messageId, fileId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(discovery.worktime_service_url+'complaint/download-complaint-message-file-by-id/'+companyId+'/'+complaintId+'/'+messageId+'/'+fileId, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    }, 

    /////////////////////////////////////////////////////////////////
    // COMPLAINTCONFIG

    getComplaintExternalContentByCompanyId(companyId, cbok, cberr)
    {
        this.genericGet('complaint/get-complaint-external-content-by-company-id/' + companyId, cbok, cberr);
    },
    updateMyCompany (data, cbok, cberr)
    {
        this.genericPost('admin/company', data, cbok, cberr);
    },
    updateComplaintTerm(companyId, cbok, cberr)
    {
        this.genericPut('complaint/update-complaint-term', companyId, cbok, cberr);
    },
    updateComplaintExternalContent(data, cbok, cberr)
    {
        this.genericPut('complaint/update-complaint-external-content', data, cbok, cberr);
    },  

    ////////////////////////////////////////////////////
    //WEBHOOKS

    getWebhookById(id, cbok, cberr)
    {
        this.genericGet('admin/webhookById/'+id, cbok, cberr);
    },  
	storeWebhook(data, cbok, cberr)
    {
        this.genericPost('admin/webhook', data, cbok, cberr);
    },    
	deleteWebhook(id, cbok, cberr)
    {
        this.genericDelete('admin/webhook/'+id, cbok, cberr);
    },   

    ////////////////////////////////////////////////////
    //ACTIVITY_TYPE

    /*getProjects(cbok, cberr)
    {
        this.genericGet('admin/projectsAll', cbok, cberr);
    }, 
    getEmployee(data, cbok, cberr)
    {
        this.genericGet('admin/employee', data, cbok, cberr);
    },*/

    ////////////////////////////////////////////////////
    //TELEWORK

    getFullDailyWorkdayById(id, cbok, cberr)
    {
        this.genericGet('admin/fullDailyWorkday/'+id, cbok, cberr);
    },
    sendMessage(data, cbok, cberr)
    {
        this.genericPost('admin/message', data, cbok, cberr);
    }, 

    ////////////////////////////////////////////////////
    //HOJA DE GASTOS
    
    getExpenseSheetById(id, cbok, cberr)
    {
        this.genericGet('admin/expense-sheet/'+id, cbok, cberr);
    },
    downloadExpenseSheetItemDocument (sheetId, sheetItemId, cbok, cberr)
    {
        let options = this.getCommonHeaders();
        options.responseType= 'blob';
        HTTP
            .get(`${discovery.worktime_service_url}admin/expense-sheet-item/${sheetId}/download/${sheetItemId}`, options)
            .then((response) => {
                if (cbok) {
                    cbok(response.data);
                }
                
                UTILS.downloadDocument(response);

            }).catch(function (error) {
                if (cberr) {
                    cberr(error);
                }
            });
    },
    getExpensesCountByExpenseCategoryId(id, cbok, cberr)
    {
        this.genericGet(`admin/expense-sheet-category/${id}/count`, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //MI LICENCIA

    getSKULicensingInfo(cbok, cberr)
    {
        this.genericGet('admin/skuLicensingInfo', cbok, cberr);
    },
    validateVoucher(data, cbok, cberr)
    {
        this.genericPost('admin/validateVoucher', data, cbok, cberr);
    },
    createPurchaseOrder(data, cbok, cberr)
    {
        this.genericPost('admin/purchaseOrder', data, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //WORKPLACES

    getWorkplaceById(id, cbok, cberr)
    {
        this.genericGet('admin/workPlaces/'+id, cbok, cberr);
    },
    getEmployeeCountByWorkPlace(id, cbok, cberr) 
    {
        this.genericGet('admin/employeeCountByWorkPlace/'+id, cbok, cberr);
    },
	storeWorkplace(data, cbok, cberr)
    {
        this.genericPost('admin/workPlaces', data, cbok, cberr);
    },
	deleteWorkplace(id, cbok, cberr)
    {
        this.genericDelete('admin/workPlaces/'+id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //WORKPLACES-HOLIDAYS

    getWorkplaceHolidays(id, cbok, cberr)
    {
        this.genericGet('admin/workplaceHolidays/'+id, cbok, cberr);
    },
    deleteWorkplaceHoliday(id, cbok, cberr)
    {
        this.genericDelete('admin/workplaceHoliday/'+id, cbok, cberr);
    },
    storeWorkplaceHoliday(data, cbok, cberr)
    {
        this.genericPost('admin/workplaceHoliday', data, cbok, cberr);
    },   

    ////////////////////////////////////////////////////
    //EQUIPOS / PROYECTOS

    getProjectById(id, cbok, cberr)
    {
        this.genericGet('admin/project/'+id, cbok, cberr);
    },
    getFullProjectsEmployeesByProjectId(id, cbok, cberr)
    {
        this.genericGet('admin/fullProjectsEmployeesByProjectId/'+ id, cbok, cberr);
    },
    createProject(data, cbok, cberr) 
    {
        this.genericPost('admin/createProject', data, cbok, cberr);
    },
    storeProject(data, cbok, cberr) {
        this.genericPost('admin/project', data, cbok, cberr);  
    },
    deleteProjectById(id, cbok, cberr) 
    {
        this.genericDelete('admin/project/'+id, cbok, cberr);
    },
    geFullProjectEmployeesByProjectList(data, cbok, cberr) 
    {
        this.genericGet('admin/geFulltProjectEmployeesByProjectList', data, cbok, cberr);
    },
    deleteProjectEmployeesByProjectList(data, cbok, cberr) 
    {
        this.genericPost('admin/deleteProjectEmployeesByProjectList', data, cbok, cberr);
    },
    addProjectEmployees(data, cbok, cberr)
    {
        this.genericPost('admin/addProjectEmployee', data, cbok, cberr);
    },
    storeProjectEmployee(data, cbok, cberr) 
    {
        this.genericPost('admin/projectEmployee', data, cbok, cberr);
    },
    deleteProjectEmployeeById(id, cbok, cberr) 
    {
        this.genericDelete('admin/project/employees/'+id, cbok, cberr);
    },

    ////////////////////////////////////////////////////
    //REGLAS DE CALENDARIO

    getCalendarRulesByCalendarId(calendarId, cbok, cberr)
    {
        this.genericGet(`admin/calendar-rule/list/${calendarId}`, cbok, cberr);
    },
    storeCalendarRule(data, cbok, cberr)
    {
        this.genericPost('admin/calendar-rule', data, cbok, cberr);
    },
    deleteCalendarRuleById(id, cbok, cberr)
    {
        this.genericDelete(`admin/calendar-rule/${id}`, cbok, cberr);
    },
    swapCalendarRules(calendarId, id1, id2, cbok, cberr)
    {
        this.genericPost(`admin/calendar/${calendarId}/swap-rules/${id1}/${id2}`, null, cbok, cberr);
    },
    executeCalendarRulesByCalendarId(calendarId, data, cbok, cberr)
    {
        this.genericPost(`admin/calendar/${calendarId}/execute-rules`, data, cbok, cberr);
    },
    copyCalendarRules(srcCalendarId, dstCalendarId, cbok, cberr)
    {
        this.genericPost(`admin/calendar/${srcCalendarId}/copy-rules/${dstCalendarId}`, null, cbok, cberr);
    },
    getFullCalendars(cbok, cberr)
    {
        this.genericGet('admin/full-calendar', cbok, cberr);
    },
    createNextCalendarExercise(calendarId, cbok, cberr)
    {
        this.genericPost(`admin/calendar/${calendarId}/create-next-exercise`, null, cbok, cberr);
    },

}